import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class EmployeeRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Nettó fizetés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.employee.name}</TableCell>
                            <TableCell>{this.props.row.employee.currentNetSalary}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default EmployeeRow;